import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    addNumber: {
        id: '_.modal.onfido_verification.add_number',
        defaultMessage: 'Add a number'
    },
    select: {
        id: '_.modal.onfido_verification.selectPlaceholder',
        defaultMessage: 'Select number'
    }
});
